export default __webpack_public_path__ + "static/media/seLigaLogo.ad922853.png";